import { styled } from '@linaria/react';

export const EvergreenContainer = styled.article`
  width: 100%;
  margin-bottom: 40px;
  background-color: var(--ogm-white);
  padding: 16px 0 0;
  border: 1px solid var(--ogm-border-color-1);
  border-radius: 5px;
  overflow: hidden;

  & article {
    border-top: 1px solid var(--ogm-border-color-1);
  }

  & img {
    max-height: 100%;
    max-width: 100%;
    padding: 0 20px;
  }

  & h2 {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1%;
    font-family: var(--ogm-font-family-2);
    color: var(--ogm-title-bg-color-1);
  }

  & p {
    font-size: 12px;
    font-weight: 500;
    font-family: var(--ogm-font-family-2);
    padding: 3px 20px;
    color: var(--ogm-title-bg-color-1);
    line-height: 18px;
  }

  & a {
    font-size: 12px;
    font-weight: 500;
    font-family: var(--ogm-font-family-2);
    color: var(--ogm-title-bg-color-1);
    text-decoration: underline;
  }

  & article div p:first-child {
    padding-top: 0;
  }

  & article div p:last-child {
    padding-bottom: 0;
  }

  & > h2 {
    margin: 0 20px;
  }

  & > p {
    margin: 10px 20px 16px;
    padding: 0;
  }

  & article div {
    &.contentContainer {
      padding: 0;
      overflow: hidden;
      max-height: 0px;
      will-change: max-height, padding;
      transition: all 0.7s;
    }
  }

  & article header {
    width: 100%;
    padding: 0 20px;
    min-height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-betwwen;
    cursor: pointer;
    background-color: white;
    transition: background-color 0.3s;

    &.open + div.contentContainer {
      max-height: 500px;
      padding: 0 0 16px;
      transition: all 0.8s;
    }

    &:hover {
      background-color: rgb(251, 251, 251);
      transition: background-color 0.3s;
    }
  }

  & article header::after {
    content: '';
    margin-left: auto;
    display: block;
    width: 13px;
    height: 13px;
    border-top: 2px solid #000;
    border-left: 2px solid #000;
    border-color: var(--ogm-title-bg-color-1);
    border-radius: 1px;
    transform: rotateZ(-135deg);
    transition: transform 0.5s;
  }

  & article header.open::after {
    transform: rotateZ(-315deg);
    transition: transform 0.5s;
  }
`;
